import React from "react";
import { Card, Button } from "antd";
import { STATUSES } from "../../../data/statuses";

export default function LeadCard({ lead, onMove }) {
  const next = STATUSES[STATUSES.findIndex((s) => s.key === lead.status) + 1];

  return (
    <Card style={{ marginBottom: 8 }}>
      <b>{lead.clientName}</b>
      <div>{lead.address}</div>

      {onMove && next && (
        <Button block type="primary" onClick={() => onMove(lead.id, next.key)}>
          → {next.title}
        </Button>
      )}
    </Card>
  );
}
